const DefaultData = {
    APISERVERURL: 'https://b2cclienttravel.azurewebsites.net/api/',
    APILOCALURL: 'http://localhost:5126/api/',
    APIACTIVEURL: 'https://b2cclienttravel.azurewebsites.net/api/',
    DEFAULTCOMPANYID: 'efd32bd2-6639-42ed-9b1a-7e262da1be07',
    DEFAULTBRANCHID: 'd6c4fbf0-f59b-4e38-a8f5-ea643ca4eaaf',
    DEFAULTUSERID: '943dc74f-1386-4baf-9861-d42cd5f4f37d',
    DEFAULTCURRENCY: 'INR',
    DEFAULTPAYMENTGATEWAYFEE: 2.5,
    WEBSITE:'https://trawtel.com',
    DEFAULTCOMPANYEMAIL: 'support@trawtel.com',
    DEFAULTCOMPANYPHONENUMBER: '9123456789',
    DEFAULTCOMPANYWHATSAPPNUMBER:'9123456789',
    DEFAULTCOMPANYGST: '36AAWCS4809A1Z6',
    DEFAULTCOMPANYNAME: 'SAAR DEVELOPERS CODE PRIVATE LIMITED',
    DEFAULTBRANDNAME: 'TRAWTEL',
    DEFAULTCOMPANYADDRESS:'HYDERABAD, TELANGANA',
    FACEBOOKURL:'https://www.facebook.com/trawtel',
    TWITTERURL:'https://x.com/trawtel',
    INSTGRAMURL:'https://www.instagram.com/trawtel',
    THEMECOLOR1:"#FBC027",
    THEMECOLOR2:"#1a1a1a",
    THEMECOLOR3:"#ffffff",
    THEMECOLOR4:"#000000",
    LANDINGPAGETITLE:"Empowering the Future of Travel Booking",
    LANDINGPAGESUBTITLE:"One stop solution for your travel business",
    B2BWEBSITE:"https://b2b.trawtel.com/",
    FOOTERCOPYRIGHTS:"2015 - 2025  All Rights Reserved.",
    FOOTERSUBTITLE:"We make your dream more beautiful & enjoyable with lots of happiness.",
    TENANTID: 'trawtel',
    COMPANYTYPE: "CUSTOM",
    USERTYPE: "CUSTOMER",
    PLANTYPE:"CUSTOM"
};

export default DefaultData;